import React from 'react';

export function StarIcon() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="Hint asset">
				<path
					id="Star 1"
					d="M15.1846 5.77031C15.5594 4.22444 17.5014 3.71351 18.5884 4.87476L23.7204 10.3571C24.1349 10.8 24.7281 11.0308 25.3329 10.9845L32.8206 10.4121C34.4066 10.2908 35.4926 11.9799 34.7241 13.3725L31.096 19.9474C30.8029 20.4785 30.7667 21.114 30.9976 21.6749L33.8558 28.6192C34.4613 30.0902 33.1905 31.645 31.6285 31.3445L24.2542 29.9256C23.6585 29.811 23.043 29.9729 22.5808 30.3659L16.8597 35.2301C15.6478 36.2605 13.7764 35.5324 13.5796 33.954L12.6502 26.5022C12.5751 25.9002 12.2309 25.3648 11.7144 25.0467L5.32024 21.1087C3.96585 20.2746 4.08003 18.2698 5.52036 17.5948L12.3203 14.4082C12.8695 14.1508 13.2723 13.658 13.4153 13.0684L15.1846 5.77031Z"
					fill="#8252DD"
				/>
				<g id="Group 1938">
					<path
						id="Vector"
						d="M22.0156 20.3344C22.2442 17.3818 20.0359 14.803 17.0834 14.5745C14.1308 14.3459 11.552 16.5542 11.3235 19.5067C11.0949 22.4593 13.3032 25.0381 16.2558 25.2666C19.2083 25.4952 21.7871 23.2869 22.0156 20.3344Z"
						fill="white"
					/>
					<path
						id="Vector_2"
						d="M28.3911 21.9317C30.1378 19.5404 29.6153 16.1857 27.2239 14.439C24.8326 12.6922 21.4779 13.2147 19.7312 15.6061C17.9844 17.9975 18.5069 21.3521 20.8983 23.0989C23.2897 24.8456 26.6443 24.3231 28.3911 21.9317Z"
						fill="white"
					/>
					<path
						id="Vector_3"
						d="M27.1086 9.96855L21.41 10.8562C20.8519 10.9432 20.4699 11.4661 20.5568 12.0242L20.7263 13.1123C20.8133 13.6704 21.3362 14.0524 21.8943 13.9655L27.5929 13.0778C28.151 12.9909 28.533 12.4679 28.4461 11.9098L28.2766 10.8217C28.1896 10.2636 27.6667 9.88161 27.1086 9.96855Z"
						fill="#000A23"
					/>
					<path
						id="Vector_4"
						d="M16.1646 11.8208L10.4288 12.423C9.86702 12.482 9.45944 12.9852 9.51842 13.5469L9.63341 14.6422C9.69239 15.2039 10.1956 15.6115 10.7574 15.5525L16.4932 14.9503C17.0549 14.8913 17.4625 14.3881 17.4035 13.8263L17.2885 12.7311C17.2296 12.1694 16.7263 11.7618 16.1646 11.8208Z"
						fill="#000A23"
					/>
					<path
						id="Vector_5"
						d="M20.5328 19.8437C20.5436 18.1648 19.1912 16.7951 17.5124 16.7844C15.8335 16.7737 14.4638 18.126 14.453 19.8049C14.4423 21.4838 15.7946 22.8535 17.4735 22.8642C19.1524 22.8749 20.5221 21.5226 20.5328 19.8437Z"
						fill="#000A23"
					/>
					<path
						id="Vector_6"
						d="M25.7709 20.5644C26.7445 19.2316 26.4532 17.3619 25.1204 16.3884C23.7876 15.4148 21.9179 15.7061 20.9444 17.0389C19.9709 18.3717 20.2621 20.2414 21.5949 21.2149C22.9277 22.1885 24.7974 21.8972 25.7709 20.5644Z"
						fill="#000A23"
					/>
					<path
						id="Ellipse 62"
						d="M21.7009 27.9999C22.8264 27.8246 23.6441 26.8873 23.7105 25.7951C23.7278 25.5114 23.4585 25.3174 23.1777 25.3611L19.4914 25.9354C19.2106 25.9791 19.0131 26.2458 19.1158 26.5108C19.5113 27.5311 20.5753 28.1752 21.7009 27.9999Z"
						fill="#27292C"
					/>
				</g>
			</g>
		</svg>
	);
}
